import { Injectable } from '@angular/core';
import { HttpClient, 
  HttpHeaders,
  HttpErrorResponse,
  HttpResponse, 
  HttpParams } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import { UserService } from './user.service';
import { AppSettingsService } from './app-settings.service';
import { DialogAuthProvider } from './../classes/DialogAuthProvider';
import { DialogConfig, DialogClaim } from './../models/dialogconfig';

import { DateUtils } from '../utils/date-utils';

@Injectable()
export class McHttpService {
  private appSettings: AppSettingsService;
  private customOptions: any;
  private dialogConfig: DialogConfig;
  private dialogAuthProvider: DialogAuthProvider

  constructor(private http: HttpClient, appSettings: AppSettingsService, private userService: UserService) {
    this.appSettings = appSettings;
    this.dialogConfig = this.getAuthConfig();;
    this.dialogAuthProvider = new DialogAuthProvider(this.dialogConfig, appSettings);
  }

  private getAuthConfig(): DialogConfig {
    //this.customOptions = new RequestOptions({ headers: new Headers({}) });
    this.customOptions = {
      headers: new HttpHeaders() ,
      responseType: "json",
    };
    let claim: DialogClaim = {
      'type': 'user',
      'isAdmin': false,
      'groups': [{ type: "group", name: "Everyone", externalId: "3958c591-7817-4c47-92bb-23f6e5c4c5a0" }],
      'name': this.userService.CurrentUser.firstName.concat(" ", this.userService.CurrentUser.lastName),
      'externalId': this.userService.CurrentUser.personId
    },
      config: DialogConfig = {
        AppKey: this.appSettings.MessageCenterAppKey,
        AppSecret: this.appSettings.MessageCenterAppSecret,
        Claim: claim,
        GlobalAllowComments: false,
        GlobalAllowLikes: false,
        ServiceUrl: this.appSettings.MessageCenterBaseUrl,
        ShowAudiences: false,
        SignalRHub: '/signalr'
      };
    this.customOptions.url = this.appSettings.MessageCenterBaseUrl.concat('/api/access/authorize');
    this.customOptions.method = "post";
    this.customOptions.responseType = "json";

    return config;
  }

  authMessageCenter(): any {
    let authRequestHeaders = this.dialogAuthProvider.buildAuthRequestHeader(this.customOptions);
    return this.post(authRequestHeaders.url, this.customOptions.body);
  }

  getNotificationCount() {
    return this.authMessageCenter()
      .mergeMap(res => {
        this.buildToken(res);        
        return this.get(this.buildUrl(res), this.customOptions);
      });
  }
  private buildToken(res) {
    let authorizedResponse = this.dialogAuthProvider.buildAuthorizedResponseObject(res);
    this.customOptions = this.dialogAuthProvider.buildRequestOptions(authorizedResponse);
  }

  private buildUrl(res) {
    let userId = res.id,
      lastLogin = DateUtils.format(res.updatedOn, "YYYY-MM-DDTHH:mm:ss");
    return this.appSettings.MessageCenterBaseUrl.concat(`/api/notification/Count?UserId=${userId}&LastLogin=${lastLogin}`);
  }

  get(endpoint: string, options?: any): Observable<any> {
    return this.http
      .get(endpoint, options)
      .catch((e) => {
        return this.error(e);
      });
  }

  post(endpoint, data?): Observable<any> {
    return this.http
      .post(endpoint, data, this.customOptions)
      .catch((e) => {
        return this.error(e);
      });
  }

  error(e): any {
    if (this.appSettings.IsDebugEnabled) console.log(e);
    return throwError(e);
  }
}
